import { NewPriceIcon } from '@/NewPrice';

type Props = {
  discountedPrice: number;
  showNewPriceIcon?: boolean;
};

export default function Price({ discountedPrice, showNewPriceIcon }: Props) {
  return (
    <div data-qa="price" className="flex font-bold gap-8 items-center text-2xl">
      {showNewPriceIcon && <NewPriceIcon data-qa="new-price-icon" />}
      ${discountedPrice.toLocaleString()}
    </div>
  );
}
